import {FC, ReactNode} from 'react';
import clsx from 'clsx';

export type PanelProps = {
    children: ReactNode;
    className?: string;
    contentClassName?: string;
    title: string;
};

const Panel: FC<PanelProps> = ({
    children,
    className,
    contentClassName,
    title,
}) => (
    <article
        aria-label={title}
        className={clsx(
            'border border-grey-300 rounded-md text-base',
            className,
        )}
    >
        <div className="border-b border-b-grey-300 px-4 py-2 bg-grey-200 rounded-t-md">
            <span className="font-medium">{title}</span>
        </div>
        <div className={clsx('p-4 bg-white rounded-b-md', contentClassName)}>
            {children}
        </div>
    </article>
);

export default Panel;
